"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getState = void 0;
var createState = function () { return ({
    eventQueue: [],
    middlewares: [],
    sinks: []
}); };
var serverState;
var getState = function () {
    if (typeof window === 'undefined') {
        if (!serverState) {
            serverState = createState();
        }
        return serverState;
    }
    if (!window.__pmiAnalyticsLayerState__) {
        window.__pmiAnalyticsLayerState__ = createState();
    }
    return window.__pmiAnalyticsLayerState__;
};
exports.getState = getState;
